import { PRODUCTS_FILTERS, RESORT_GRID, RESORT_RECOMMENDATIONS } from 'Cms/constants';
export type LineProps = {
  name?: string;
  props: any;
};
export const getMinPrice = (
  { name, props: { lines = [], ...props } }: LineProps,
  minPrice: any,
) => {
  if ([PRODUCTS_FILTERS, RESORT_GRID, RESORT_RECOMMENDATIONS].includes(name)) {
    const products =
      props.products || props.recommendations?.products || props.offer?.products || [];
    minPrice = products.reduce((min, product) => {
      return (product.price?.bestPrice?.value &&
        product.price.bestPrice.value < min?.bestPrice?.value) ||
        !min?.bestPrice?.value
        ? product.price
        : min;
    }, minPrice);
  }

  if (lines.length > 0) {
    lines.forEach((line) => {
      minPrice = getMinPrice(line, minPrice);
    });
  }

  return minPrice;
};
